/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./add-resource-to-used.vue?vue&type=template&id=7674ffb8&scoped=true&"
import script from "./add-resource-to-used.vue?vue&type=script&lang=ts&"
export * from "./add-resource-to-used.vue?vue&type=script&lang=ts&"
import style0 from "./add-resource-to-used.vue?vue&type=style&index=0&id=7674ffb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7674ffb8",
  null
  
)

export default component.exports